import axios from "axios";

const FSCOCKPIT_API_BASE_URL = process.env.REACT_APP_FS_COCKPIT_BASE_URL;

const fsCockpitClient = axios.create({
  baseURL: FSCOCKPIT_API_BASE_URL
});


export interface FSCockpitLoginResponse {
  username: string
  roles: string[]
  token_type: "Bearer"
  access_token: string
  expires_in: number
  refresh_token: string
}

function login(userName: string, password: string): Promise<FSCockpitLoginResponse> {
  return fsCockpitClient.request({
    method: 'POST',
    url: '/token',
    responseType: 'json',
    data: {
      username: userName,
      password: password
    }
  }).then(response => response.data as FSCockpitLoginResponse);
}

function refresh(refreshToken: string): Promise<FSCockpitLoginResponse> {
  return fsCockpitClient.request({
    method: 'GET',
    url: '/oauth/token',
    params: {
      grant_type: 'refresh_token',
      refresh_token: refreshToken
    }
  }).then(response => response.data as FSCockpitLoginResponse);
}

export const fsCockpitAuthApi = {
  login,
  refresh
};